<template>
  <li class="right hidden-xs hidden-sm">
    <router-link
      :to="{ name: 'VenueScheduler' }"
      style="background-color: #FFFFFF !important;"
    >
      <img
        class="vlogo"
        src="https://manager.venuzle.at/assets/images/v.png"
        width="22"
        alt="Venuzle"
      />
    </router-link>
    <div class="grid-container3" v-show="partners.length > 1">
      <ul>
        <li :key="partner.id" v-for="partner in partners">
          <a
            @click="() => onChangePartner(partner)"
            :class="{ 'partner-active': partner.id === partnerId }"
            class="pointer"
          >
            <i class="fa fa-check" v-show="partner.id === partnerId"></i>
            {{ partner.name }}
          </a>
        </li>
      </ul>
    </div>
  </li>
</template>

<script>
import Api from "@/api.js";

export default {
  name: "Partners.vue",

  data() {
    return {
      selectedPartner: null,
      partners: [],
      partnerId: parseInt(localStorage.partnerId, 10)
    };
  },

  mounted() {
    this.getPartners();
  },

  methods: {
    onChangePartner(partner) {
      this.selectedPartner = partner;
    },

    getPartners() {
      Api()
        .get("api/internal/v1/users/current/partners")
        .then(response => {
          this.partners = response.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    }
  },

  watch: {
    selectedPartner(newState) {
      localStorage.setItem("partnerId", newState.id);
      localStorage.setItem("partnerCode", newState.code);
      this.partnerId = newState.id;
      window.location.reload();
    }
  }
};
</script>

<style>
.partner-active {
  color: #3aa94c !important;
}
</style>
